<template>
  <template v-if="salariéEnCours">
    <div class="element__detail">
      <div class="flex flex-gap-1">
        <BasicText
          size="h4"
          weight="bold"
        >
          Saisie Salarié(e)
        </BasicText>
        <BasicIcon
          @click="définirSalariéEnCours(null)"
          name="close"
          class="element__detail--hide"
        />
      </div>
      <BasicButton
        v-if="!readonly"
        variant="outlined"
        label="Supprimer"
        icon-name="minus-square"
        class="element__detail--delete"
        @click="onDeleteSalarie(activeSalariéIndex!)"
      />
    </div>
    <template v-if="saisieAdherent">
      <InformationsSalarie :id="idScrollDownToSaisie" />
      <AdresseSalarie />
      <InformationsComplementaires />
    </template>
    <InformationsSalariePrestataire
      v-else
      :id="idScrollDownToSaisie"
    />
  </template>
</template>

<script setup lang="ts">
  import { computed, inject } from 'vue'
  import { storeToRefs } from 'pinia'
  import { useDemandeAFStore } from '@/features/interface/demande/af/useDemandeAFStore'
  import { SalarieActionKey, type SalarieAction } from '@/features/interface/demande/af/steps/salarie/useSalarieActions'
  import InformationsSalarie from '../informations/InformationsSalarie.vue'
  import InformationsSalariePrestataire from '../informations/InformationsSalariePrestaire.vue'
  import AdresseSalarie from '../adresse/adresseSalarie.vue'
  import InformationsComplementaires from '../informations/InformationsComplementaires.vue'
  import { TypesContextesAutorisesEnum } from '@/features/auth/context-app'
  import { useDialog } from '@/features/interface/dialog'

  const store = useDemandeAFStore()

  const { readonly, typeContextCourant } = storeToRefs(store)
  const { activeSalariéIndex, salariéEnCours, définirSalariéEnCours, supprimerSalarié, idScrollDownToSaisie } =
    inject<SalarieAction>(SalarieActionKey)!

  const onDeleteSalarie = async (index: number) => {
    const dialog = useDialog()
    const result = await dialog.showDialog({
      message: `Confirmez-vous la suppression du salarié ${salariéEnCours.value?.prenom ?? ''} ${salariéEnCours.value?.nomNaissance ?? ''} ?`,
      type: 'YesNo',
      title: 'Supprimer de la liste',
    })

    if (result === 'Yes') supprimerSalarié(index)
  }

  const saisieAdherent = computed(() => typeContextCourant.value === TypesContextesAutorisesEnum.Adherent)
</script>
